import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DashboardContainer } from 'components';
import Body from './Body';
import API from 'services/api';

const Index = () => {
  const dispatch = useDispatch();
  const [searchFromDate, setSearchFromDate] = useState('');
  const [searchToDate, setSearchToDate] = useState('');
  const [searchFieldOption, setSearchFieldOption] = useState({
    'HSPP ID': 'hspp_id',
    'Patient ID': 'customer_id',
    'First Name': 'first_name',
    'Last Name': 'last_name',
    Email: 'email',
    'Created At': 'createdAt'
  });
  const [tableData, setTableData] = useState([]);
  const [initialData, setInitialData] = useState({ total_pages: 0, data: [], total_items: 0 });
  const [count, setCount] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [limitPerPage, setLimitPerPage] = useState(20);
  const [payload, setPayload] = useState(null);
  const [search, setSearch] = useState({ searchField: '', searchInput: '' });

  useEffect(() => {
    fetchData(0, limitPerPage, null, true);
  }, []);

  useEffect(() => {
    if (search === '') {
      setTableData(initialData.data);
    }
  }, [search]);

  const fetchData = async (
    page,
    limit,
    searchPayload,
    initial = false,
    sortingField = 'createdAt',
    sortingDirection = false
  ) => {
    dispatch(loadingStart());
    const apiCall = searchPayload
      ? API.getDeletedCustomerListBySearch(
          page,
          limit,
          searchPayload,
          sortingField,
          sortingDirection
        )
      : API.getDeletedCustomerList(page, limit, sortingField, sortingDirection);

    await apiCall
      .then((response) => {
        if (response) {
          setTableData(response.data);
          if (initial) {
            setInitialData(response);
          }
          if (response.total_pages >= 0) setTotalPage(response.total_pages);
          if (response.total_items >= 0) setCount(response.total_items);
        }
        if (page < 1) setCurrentPage(0);
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  const searchData = (e) => {
    if (e) e.preventDefault();
    const searchPayload = { ...search };
    if (searchPayload.searchField) {
      if (searchPayload.searchField === 'createdAt') {
        const fromDate = moment(searchFromDate).format('YYYY-MM-DD');
        const toDate = moment(searchToDate).add(1, 'days').format('YYYY-MM-DD');
        searchPayload.searchInput = `${fromDate}to${toDate}`;
      }
      setPayload(searchPayload);
      setCurrentPage(0);
      fetchData(0, limitPerPage, searchPayload);
    } else {
      setPayload(null);
      setTableData(initialData.data);
      setTotalPage(initialData.total_pages);
      setCount(initialData.total_items);
      setCurrentPage(0);
    }
  };

  const RestoreCustomer = async (id) => {
    dispatch(loadingStart());
    await API.restoreCustomer({ id })
      .then((response) => {
        if (response) {
          toast.success('Customer restored successfully');
          fetchData(currentPage, limitPerPage, payload);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  return (
    <DashboardContainer>
      <Body
        _this={{
          setSearch,
          search,
          searchData,
          searchFieldOption,
          setSearchFieldOption,
          searchFromDate,
          setSearchFromDate,
          searchToDate,
          setSearchToDate,
          RestoreCustomer,
          currentPage,
          setCurrentPage,
          fetchData,
          tableData,
          count,
          totalPage,
          limitPerPage,
          setLimitPerPage,
          payload
        }}
      />
    </DashboardContainer>
  );
};

export default Index;
